// Dialogs can unmount in parent-first order. Restore scrolling only after the
// last owner releases, regardless of the order in which they were opened.
const owners = new Set();
let original = '';
export function lockBodyScroll(body = document.body) {
  if (!owners.size) original = body.style.overflow;
  const owner = {}; owners.add(owner); body.style.overflow = 'hidden';
  return () => {
    if (!owners.delete(owner)) return;
    if (!owners.size) body.style.overflow = original;
  };
}
